import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions, formatDate } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "code",
		headerName: "Tax Code",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "country",
		headerName: "Country",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value?.name,
	},
	{
		field: "enabled",
		headerName: "Enabled",
		minWidth: 140,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},
	{
		field: "isDefault",
		headerName: "Default",
		minWidth: 140,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},
	{
		field: "startDate",
		headerName: "Start Date",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header grey-background",
		valueGetter: (params: GridValueGetterParams) => {
			const onBoardingDate = formatDate(params);
			return onBoardingDate;
		},
	},
	{
		field: "endDate",
		headerName: "End Date",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header grey-background",
		valueGetter: (params: GridValueGetterParams) => {
			const onBoardingDate = formatDate(params);
			return onBoardingDate;
		},
	},
	{
		field: "effectiveDate",
		headerName: "Effective Date",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header grey-background",
		valueGetter: (params: GridValueGetterParams) => {
			const onBoardingDate = formatDate(params);
			return onBoardingDate;
		},
	},
	{
		field: "expiryDate",
		headerName: "Expiry Date",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header grey-background",
		valueGetter: (params: GridValueGetterParams) => {
			const onBoardingDate = formatDate(params);
			return onBoardingDate;
		},
	},
	
	...createdAtmodifiedAtActions
];
